


























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { SystemApi, WorkordersApi, PerformoSettings } from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';
import TradePicker from '@/components/system/TradePicker.vue';

@Component({
  components: { EditOnClickField, TradePicker },
  computed: mapGetters({
    currentUser: 'currentUser',
    ordersApi: 'ordersApi',
    systemApi: 'systemApi',
    settings: 'settings'
  })
})
export default class TradeEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: '' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  private settings!: PerformoSettings;

  private TradeMode = 'read';
  private currentUser!: User;
  private updatedValue: string | number | undefined = undefined;
  private loading!: boolean;

  private systemApi!: SystemApi;
  private ordersApi!: WorkordersApi;

  get tradeLabel(): string {
    return this.settings?.tradeLabel || 'Trade';
  }

  data() {
    return {
      loading: false,
      updatedValue: this.value
    };
  }

  // valueUpdate getter and setters are not referenced anywhere. Remove?
  // https://dev.azure.com/wizardsoftware/Performo.Api/_workitems/edit/1980/
  get valueUpdate() {
    return this.updatedValue || this.value;
  }
  set valueUpdate(val) {
    this.updatedValue = val;
  }

  private async handleTradeChange(Trade: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === Trade) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeTrade({
        workorderId: this.workorderId,
        changeOrderTradeCommand: {
          newTrade: Trade
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.TradeMode = 'read';
    this.loading = false;
  }
}
